const STEP_ARROW_SVG = `<svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="currentColor"/></svg>`;

export type ArchiveStepButtonOptions = {
  disabled?: boolean;
  title?: string;
  onClick?: () => void;
  class?: string;
};

/** Bouton flèche (style cssbuttons-io) — `next` : icône à droite ; `prev` : variante miroir. */
export function createArchiveStepButton(
  label: string,
  direction: 'prev' | 'next',
  opts: ArchiveStepButtonOptions = {}
): HTMLButtonElement {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = `archives-step-btn archives-step-btn--${direction}${opts.class ? ` ${opts.class}` : ''}`;
  if (opts.title) btn.title = opts.title;
  btn.disabled = opts.disabled ?? false;
  if (opts.onClick) btn.addEventListener('click', opts.onClick);

  const icon = document.createElement('span');
  icon.className = 'archives-step-btn__icon';
  icon.innerHTML = STEP_ARROW_SVG;

  const text = document.createElement('span');
  text.className = 'archives-step-btn__label';
  text.textContent = label;

  if (direction === 'prev') {
    btn.append(icon, text);
  } else {
    btn.append(text, icon);
  }

  return btn;
}
